export const fixJavaScriptLinks = (link) => {
  const href = link?.value?.href?.toLowerCase();

  if (href?.startsWith("javascript:") && href?.endsWith("return false;")) {
    link.value.href = link.value.href.substr(0, link.value.href.length - 13).replace(";;", ";");
  }

  return link;
};
